export const ALL_STATUS = {
  label: 'userManagement.orderManagement.ALL_STATUS',
  value: 'ALL_STATUS',
  isI18n: true,
}

export const REPORT_TYPES = {
  SCREENING: 1,
  FACT_SHEET: 2,
  CREDIT: 3,
  STANDARD: 4,
  COMPREHENSIVE: 5,
  INTERNATIONAL_REPORT: 6,
  BUSINESS_CONCIERGE: 7,
}

export const ORDER_MANAGE_KEYS = {
  ORDER: 'order',
  ORDER_DESCRIPTION: 'fiinGateReportTypeName',
  QUANTITY: 'quantity',
  DATE_ORDERED: 'createDate',
  ORDER_STATUS: 'orderStatus',
  PAYMENT_METHOD: 'paymentMethod',
  TOTAL: 'totalAmountVND',
  CONTRACT: 'contractFileUploaded',
  PAYMENT_STATUS: 'transactionStatus',
  DETAIL: 'id',
}

export const ORDER_MANAGE_TITLE = [
  { title: '#', key: ORDER_MANAGE_KEYS.ORDER },
  {
    title: 'userManagement.orderManagement.ORDER_DESCRIPTION',
    key: ORDER_MANAGE_KEYS.ORDER_DESCRIPTION,
  },
  {
    title: 'userManagement.orderManagement.VOLUME',
    key: ORDER_MANAGE_KEYS.QUANTITY,
  },
  {
    title: 'userManagement.orderManagement.DATE_ORDERED',
    key: ORDER_MANAGE_KEYS.DATE_ORDERED,
  },
  {
    title: 'userManagement.orderManagement.ORDER_STATUS',
    key: ORDER_MANAGE_KEYS.ORDER_STATUS,
  },
  {
    title: 'userManagement.orderManagement.PAYMENT_METHOD',
    key: ORDER_MANAGE_KEYS.PAYMENT_METHOD,
  },
  {
    title: 'userManagement.orderManagement.TOTAL',
    key: ORDER_MANAGE_KEYS.TOTAL,
  },
  {
    title: 'userManagement.orderManagement.PAYMENT_STATUS',
    key: ORDER_MANAGE_KEYS.PAYMENT_STATUS,
  },
  {
    title: '',
    key: ORDER_MANAGE_KEYS.DETAIL,
  },
]

export const BI_REPORTS = {
  ALL: {
    value: 'ALL',
    label: 'userManagement.orderManagement.orderDetail.ALL',
    isI18n: true,
  },
  CREDIT: {
    value: REPORT_TYPES.CREDIT,
    label: 'Credit Business Report',
    isI18n: false,
  },
  STANDARD: {
    value: REPORT_TYPES.STANDARD,
    label: 'Standard Business Report',
    isI18n: false,
  },
  COMPREHENSIVE: {
    value: REPORT_TYPES.COMPREHENSIVE,
    label: 'Comprehensive Business Report',
    isI18n: false,
  },
}

export const mapOrderStatus = {
  Completed: {
    color: '#3DA967',
    title: 'COMPLETED',
  },
  Pending: {
    color: '#F58B00',
    title: 'PENDING',
  },
  Processing: {
    color: '#2C73E8',
    title: 'PROCESSING',
  },
  Cancelled: {
    color: '#3A414B',
    title: 'CANCELLED',
  },
  Failed: {
    color: '#9C9C9C',
    title: 'FAILED',
  },
  Checking: {
    color: '#D375AE',
    title: 'CHECKING',
  },
}

export const mapTransactionStatus = {
  Pending: {
    key: 'Pending',
    color: '#F58B00',
    title: 'PENDING',
  },
  Success: {
    key: 'Success',
    color: '#3DA967',
    title: 'SUCCESS',
  },
  Checking: {
    key: 'Checking',
    color: '#D375AE',
    title: 'CHECKING',
  },
  Error: {
    key: 'Error',
    color: '#E03643',
    title: 'ERROR',
  },
  Cancelled: {
    key: 'Cancelled',
    color: '#3A414B',
    title: 'CANCELLED',
  },
}

export const TD_WIDTH = {
  ORDER_DESCRIPTION: 250,
  TOTAL: 150,
  VOLUME: 100,
  ORDER_STATUS: 150,
  DATE_ORDERED: 200,
  NO: 70,
  PAYMENT_STATUS: 300,
  PAYMENT_METHOD: 150,
}

export const PAYMENT_METHOD = {
  BankTransfers: 'userManagement.orderManagement.BANK_TRANSFERS',
  Card: 'userManagement.orderManagement.CARD',
  Package: 'userManagement.orderManagement.PACKAGE',
  PostPaid: 'userManagement.orderManagement.POSTPAID',
  Free: 'userManagement.orderManagement.FREE',
}

export const COMPLETED_STATUS = 'Completed'
export const PENDING_STATUS = 'Pending'
export const CANCELED_STATUS = 'Cancelled'

export const PAYMENT_METHOD_PACKAGE = 'Package'
export const PAYMENT_METHOD_FREE = 'Free'
